export default "__VITE_ASSET__BRs5$tWZ__"